const white = '#FFFFFF';
const black = '#282632';

export default {
    gray: {
        main: '#D5DEE3',
        light: '#899AB4',
        dark: '#516683',
        contrastText: black,
    },
    primary: {
        main: '#5A4AE8',
        light: '#9890FC',
        dark: '#443ABD',
        contrastText: white,
    },
    secondary: {
        main: '#c766ff',
        light: '#fd98ff',
        dark: '#9334cb',
        contrastText: white,
    },
    error: {
        main: '#f44336',
        light: '#FF3F51',
        dark: '#CC3051',
        contrastText: white,
    },
    warning: {
        main: '#f16d82',
        light: '#ff9fb1',
        dark: '#ba3b56',
        contrastText: white,
    },
    info: {
        main: '#0C8EFF',
        light: '#6BD3FF',
        dark: '#0C78E8',
        contrastText: white,
    },
    success: {
        main: '#20CB78',
        light: '#8AF4AB',
        dark: '#00AA83',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    }
};
